<template>
    <div class="home-grid">
        <van-grid>
            <van-grid-item icon="qr-invalid" text="分类" @click="$router.push({ path: '/categorypages' })"></van-grid-item>
            <van-grid-item icon="bar-chart-o" text="排行" @click="$router.push({ path: '/rankinglist' })"></van-grid-item>
            <van-grid-item icon="orders-o" text="书单" @click="$router.push({ path: '/bookslist' })"></van-grid-item>
            <van-grid-item icon="balance-o" text="充值" @click="$router.push({ path: '/mycenter' })"></van-grid-item>
        </van-grid>
    </div>
</template>

<script>
export default {};
</script>
<style lang="less">
.home-grid {
    .van-grid-item {
        .van-grid-item__content {
            padding: 8px;
        }
    }
}
</style>
